import Image from "next/image";
import type { FunctionComponent } from "react";
import { cn } from "cn";

interface Props {
  className?: string;
  sizePx?: number;
}

const MarketingLogo: FunctionComponent<Props> = ({
  className: _className,
  sizePx = 24,
}) => {
  const className = cn("w-fit h-fit", _className);

  return (
    <div className={className}>
      <div className="w-full h-full">
        <Image
          src="/logo/logo-circle.svg"
          alt="SF Compute Logo"
          width={sizePx}
          height={sizePx}
          style={{
            minHeight: sizePx,
            minWidth: sizePx,
          }}
        />
      </div>
    </div>
  );
};

export default MarketingLogo;
